import { observer } from "mobx-react-lite"

import { MinimalPoolStore } from "@/domains/minimal-pool"
import { HandleZapClick } from "@/pages/liquidity"

export const ZapColumn = observer(
  ({ pool, handleZapClick }: { pool: MinimalPoolStore; handleZapClick: HandleZapClick }) => {
    return (
      <div
        className="flex max-w-[60px] cursor-pointer flex-col items-center justify-center rounded-full text-xl transition-all duration-300 ease-in-out hover:shadow-[0_0_4px_rgba(251,191,36,0.6)]"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          handleZapClick(pool)
        }}
      >
        ⚡
      </div>
    )
  },
)
